import { render, staticRenderFns } from "./DuplicateIncidentPopup.vue?vue&type=template&id=6b6f2c86&"
import script from "./DuplicateIncidentPopup.vue?vue&type=script&lang=js&"
export * from "./DuplicateIncidentPopup.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIncidentPopup.vue?vue&type=style&index=0&id=6b6f2c86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports